"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLink = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var get_1 = __importDefault(require("lodash/get"));
var react_router_dom_1 = require("react-router-dom");
var fieldProcessors_1 = require("utils/fieldProcessors");
var general_1 = require("utils/general");
var BaseLink = function (_a) {
    var _b, _c;
    var children = _a.children, props = __rest(_a, ["children"]);
    var hasTo = 'to' in props && props.to !== undefined;
    var target = (_b = props.target) !== null && _b !== void 0 ? _b : (!hasTo && ((_c = props.href) === null || _c === void 0 ? void 0 : _c.startsWith('http')) ? '_blank' : undefined);
    return hasTo
        ? (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({}, props, { children: children }))
        : (0, jsx_runtime_1.jsx)("a", __assign({}, props, { href: props.href || 'https://google.com', target: target }, { children: children }));
};
exports.BaseLink = BaseLink;
var StyledLink = (0, styles_1.styled)(exports.BaseLink, { shouldForwardProp: (0, general_1.omitProps)('color', 'disabled', 'fontWeight', 'sx') })(function (_a) {
    var color = _a.color, theme = _a.theme, disabled = _a.disabled, fontWeight = _a.fontWeight, inLine = _a.inLine;
    return ({
        color: color ? (0, get_1.default)(theme.palette, color) : theme.palette.text.secondary,
        fontWeight: fontWeight
            ? theme.typography["fontWeight".concat((0, fieldProcessors_1.capitalize)(fontWeight))]
            : (inLine && theme.typography.fontWeightMedium) || undefined,
        textDecoration: inLine ? 'underline' : 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        display: inLine ? undefined : 'block',
        borderRadius: 4,
        ':hover': {
            // textDecoration: underline ? 'none' : 'underline',
            textDecoration: 'none',
        },
        ':focus-visible': __assign(__assign({}, theme.focusVisibleStyles), theme.focusVisibleLinkStyles),
    });
});
exports.default = StyledLink;
